export function initYandexMetrika() {
  if (typeof window === 'undefined') return;
  if (window.ym) return;

  (function (m: any, e: Document, t: string, r: string, i: string) {
    m[i] =
      m[i] ||
      function () {
        (m[i].a = m[i].a || []).push(arguments);
      };
    m[i].l = 1 * (new Date() as any);
    
    // Check if script is already added
    for (let j = 0; j < e.scripts.length; j++) {
      if (e.scripts[j].src === r) {
        return;
      }
    }
    
    const k = e.createElement(t) as HTMLScriptElement;
    const a = e.getElementsByTagName(t)[0];
    k.async = true;
    k.src = r;
    if (a && a.parentNode) {
      a.parentNode.insertBefore(k, a);
    } else {
      e.head.appendChild(k);
    }
  })(
    window,
    document,
    'script',
    'https://mc.yandex.ru/metrika/tag.js?id=106409064',
    'ym',
  );

  window.ym(106409064, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: window.location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}
